import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Hyperlink, Icon, Stack } from '@openedx/paragon';
import { ArrowForward } from '@openedx/paragon/icons';
import { getConfig } from '@edx/frontend-platform';

import messages from './messages';

const ExperimentalUpsellBullets = ({ isFBE, learningAssistantEnabled }) => {
  const intl = useIntl();
  return (
    <Stack role="list" gap={3} className="m-4">
      <Stack direction="horizontal" role="listitem" gap={2}>
        <Icon src={ArrowForward} size="xs" className="text-brand-500" />
        <span>
          {intl.formatMessage(messages.access)}
        </span>
      </Stack>
      {isFBE && (
        <Stack direction="horizontal" role="listitem" gap={2}>
          <Icon src={ArrowForward} size="xs" className="text-brand-500" />
          <span>
            {intl.formatMessage(messages.grades)}
          </span>
        </Stack>
      )}
      {learningAssistantEnabled && (
        <Stack direction="horizontal" role="listitem" gap={2}>
          <Icon src={ArrowForward} size="xs" className="text-brand-500" />
          <span>
            {intl.formatMessage(messages.learningAssistant)}
          </span>
        </Stack>
      )}
      <Stack direction="horizontal" role="listitem" gap={2}>
        <Icon src={ArrowForward} size="xs" className="text-brand-500" />
        <span>
          {intl.formatMessage(
            messages.certificate,
            {
              certificateLink: (
                <Hyperlink destination={`${getConfig().MARKETING_SITE_BASE_URL}/verified-certificate`}>
                  {intl.formatMessage(messages.certificateLinkText)}
                </Hyperlink>
              ),
            },
          )}
        </span>
      </Stack>
    </Stack>
  );
};

ExperimentalUpsellBullets.defaultProps = {
  isFBE: false,
  learningAssistantEnabled: false,
};

ExperimentalUpsellBullets.propTypes = {
  isFBE: PropTypes.bool,
  learningAssistantEnabled: PropTypes.bool,
};

export default ExperimentalUpsellBullets;
